// extracted by mini-css-extract-plugin
export default {"container":"error404_container__RhEwP","container1":"error404_container1__nTA-3","errorContainer":"error404_errorContainer__5ynn-"};